import { SplitInput } from 'modules/workflowNodeEditors/editorComponents/SplitEditors';
import styled from 'styled-components';
import { colors, spacing } from 'ui/theme';
import { pxToRem } from 'utils/convert';

export const SplitInputWraper = styled.div`
  display: flex;
  width: 100%;
`;

export const StyledSplitInput = styled(SplitInput)`
  width: ${pxToRem(480)};
  > :first-child {
    flex: 1;
  }
  &.default-split-input > button {
    visibility: hidden; /** Remove button is not shown for default split branch */
  }
`;

export const CheckboxLabel = styled.div`
  color: ${colors.textPrimary};
`;

export const DefaultSplit = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  margin-top: ${spacing.plusHalf};
  > :not(:first-child) {
    margin-left: ${spacing.half};
  }
`;
